
import { View } from 'react-native';
import { Case } from "@/types/workflow";
import { CaseDialogs } from "../CaseDialogs";
import { CaseHeaderSection } from "../sections/CaseHeaderSection";
import { CaseContentSection } from "../sections/CaseContentSection";
import { EmptyStateSection } from "../EmptyStateSection";
import { LoadingStateSection } from "../LoadingStateSection";
import { OnboardingTour } from "../components/OnboardingTour";
import { EnhancedSearch } from "../components/EnhancedSearch";

interface MobileCasesContentProps {
  selectedCase: Case | null;
  createDialogOpen: boolean;
  editDialogOpen: boolean;
  deleteDialogOpen: boolean;
  searchTerm: string;
  activeFilters: string[];
  filteredCases: Case[];
  isLoading: boolean;
  error: Error | null;
  onCreateCase: () => void;
  onEditDialogChange: (open: boolean) => void;
  onCreateDialogChange: (open: boolean) => void;
  onDeleteDialogChange: (open: boolean) => void;
  onSearchChange: (value: string) => void;
  onFilterChange: (filters: string[]) => void;
  onDataRefresh: () => Promise<void>;
  onEditSubmit: (values: any) => Promise<void>;
  onCreateSuccess: () => Promise<void>;
  onDeleteConfirm: () => Promise<void>;
  setSelectedCase: (caseData: Case | null) => void;
}

export function MobileCasesContent({
  selectedCase,
  createDialogOpen,
  editDialogOpen,
  deleteDialogOpen,
  searchTerm,
  activeFilters,
  filteredCases,
  isLoading,
  error,
  onCreateCase,
  onEditDialogChange,
  onCreateDialogChange,
  onDeleteDialogChange,
  onSearchChange,
  onFilterChange,
  onDataRefresh,
  onEditSubmit,
  onCreateSuccess,
  onDeleteConfirm,
  setSelectedCase,
}: MobileCasesContentProps) {
  return (
    <View style={{ flex: 1, height: '100%', overflow: 'hidden', width: '100%' }}>
      <OnboardingTour />
      <View style={{ 
        height: '100%',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
        padding: 8,
        gap: 8
      }}>
        <CaseHeaderSection
          onCreateCase={onCreateCase}
          onRefresh={onDataRefresh}
        />

        <EnhancedSearch
          onSearchChange={onSearchChange}
          onFilterChange={onFilterChange}
          cases={filteredCases}
        />

        {isLoading ? (
          <LoadingStateSection />
        ) : error ? (
          <View style={{ padding: 8 }}>
            <View style={{ backgroundColor: '#FEE2E2', padding: 8, borderRadius: 8 }}>
              <span style={{ color: '#B91C1C' }}>
                Det oppstod en feil ved lasting av saker: {error.message}
              </span>
            </View>
          </View>
        ) : filteredCases.length === 0 ? (
          <EmptyStateSection onCreateCase={onCreateCase} />
        ) : (
          <CaseContentSection
            selectedCase={selectedCase}
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
            filteredCases={filteredCases}
            isLoading={isLoading}
            error={error}
            onEdit={(caseData) => {
              setSelectedCase(caseData);
              onEditDialogChange(true);
            }}
            onDelete={(caseData) => {
              setSelectedCase(caseData);
              onDeleteDialogChange(true);
            }}
            onViewWorkflow={setSelectedCase}
            onWorkflowUpdate={onDataRefresh}
            onBack={() => setSelectedCase(null)}
          />
        )}

        <CaseDialogs
          selectedCase={selectedCase}
          createDialogOpen={createDialogOpen}
          editDialogOpen={editDialogOpen}
          deleteDialogOpen={deleteDialogOpen}
          onCreateDialogChange={onCreateDialogChange}
          onEditDialogChange={onEditDialogChange}
          onDeleteDialogChange={onDeleteDialogChange}
          onEditSubmit={onEditSubmit}
          onCreateSuccess={onCreateSuccess}
          onDeleteConfirm={onDeleteConfirm}
        />
      </View>
    </View>
  );
}
